<template>
    <div class="space-y-8 flex flex-col min-h-full bg-light-gray pb-8">
        <div class="space-y-0 lg:space-y-4 flex-1 pt-4">
            <div class="max-w-7xl mx-auto p-2 lg:p-0">
                <CompanyBrand :company="company" />
            </div>

            <div class="max-w-5xl mx-auto space-y-8 pb-8 px-2">
                <div
                    v-if="slots.title"
                    class="text-xl font-semibold text-center"
                >
                    <slot name="title" />
                </div>

                <!-- Needed because the order card in the ShowOorder.vue page has the same width -->
                <div class="max-w-3xl mx-auto">
                    <SchedulingErrorMessage
                        v-if="errorMessage"
                        :errorMessage="errorMessage"
                    />
                </div>

                <slot name="content"></slot>
            </div>
        </div>

        <GetYourOwnTinyCalPage
            v-if="isFreePlan"
            :currentLocale="LocaleEnum.English"
        />
        <Footer
            :appName="appName"
            :currentLocale="LocaleEnum.English"
            :openCookieSettingsElementId="openCookieSettingsElementId"
        />
    </div>
</template>

<script setup lang="ts">
    import { useSlots } from 'vue'
    import Company from '@/App/Company/Entity/Company'
    import GetYourOwnTinyCalPage from '@/BookingForm/BookingForm/Component/GetYourOwnTinyCalPage.vue'
    import Footer from '@/BookingForm/BookingForm/Component/Footer.vue'
    import CompanyBrand from '@/BookingForm/BookingForm/Component/CompanyBrand.vue'
    import SchedulingErrorMessage from '@/BookingForm/BookingForm/Component/SchedulingErrorMessage.vue'
    import { LocaleEnum } from '@/Shared/AutoGenerated/LocalizationEnum'

    interface MeetingLayoutProps {
        appName: string
        isFreePlan: boolean
        company: Company
        errorMessage: string | null
        openCookieSettingsElementId: string
    }

    const props = defineProps<MeetingLayoutProps>()
    const slots: any = useSlots()
</script>
